import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Select } from '@opendate-app/setlist';
import { toastError } from '../../../shared/toastHelper';

const axios = require('axios').default;

const mutedTextStyle = { color: 'var(--sl-text-tertiary)' };

const EventFundraisingSettings = ({ csrfToken, confirm, team, onSaved }) => {
  const [campaignId, setCampaignId] = useState(
    confirm.giving_campaign_id ? String(confirm.giving_campaign_id) : ''
  );
  const [isSaving, setIsSaving] = useState(false);

  const options = [
    { value: '', label: 'None' },
    ...(team.giving_campaigns || []).map(campaign => ({ value: String(campaign.id), label: campaign.name })),
  ];

  const handleChange = (value) => {
    if (value === campaignId) return;

    const previous = campaignId;
    setCampaignId(value);
    setIsSaving(true);
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    axios.patch(`/teams/${team.id}/confirms/${confirm.id}`, {
      confirm: { giving_campaign_id: value === '' ? null : value },
    })
      .then(() => onSaved(value === '' ? null : Number(value)))
      .catch(err => {
        setCampaignId(previous);
        const body = err?.response?.data;
        toastError(Array.isArray(body) ? body.join(', ') : 'Something went wrong. Try again.');
      })
      .then(() => setIsSaving(false));
  };

  return (
    <div style={{ marginTop: '40px', color: 'var(--sl-text-primary)' }}>
      <p className="mb-2"><strong>Fundraising</strong></p>
      <p className="small mb-1" style={mutedTextStyle}>
        Paid tickets for this show count toward the campaign&apos;s total.
        {team.can_access_fair_market_value ? (
          <>
            {' '}Set each ticket type&apos;s fair market value on the ticket type so donor
            statements show the deductible amount.
          </>
        ) : null}
      </p>
      <div className="mt-3 mb-3" style={{ maxWidth: '320px' }}>
        <Select
          size="sm"
          id="event-giving-campaign"
          label="Raises money for campaign"
          disabled={isSaving}
          options={options}
          value={campaignId}
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

EventFundraisingSettings.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  confirm: PropTypes.object.isRequired,
  team: PropTypes.object.isRequired,
  onSaved: PropTypes.func.isRequired,
};

export default EventFundraisingSettings;
